import { apiClient } from "@/lib/api/client"
import type {
  OtkRole,
  OtkUser,
  Permission, Role,
} from "shared"

export type { OtkRole, OtkUser, Role }

export type OtkPermission = Permission

// subject-users.md API/Data #1 — GET /api/otk/users. otk-users.ts's `/users`
// route (matches otk-be's own field names verbatim).
export async function getOtkUsers(): Promise<OtkUser[]> {
  const { data } = await apiClient.get<OtkUser[]>("/otk/users")
  return data
}

// subject-roles.md API/Data #1 — GET /api/otk/roles.
export async function getOtkRoles(): Promise<OtkRole[]> {
  const { data } = await apiClient.get<OtkRole[]>("/otk/users/roles")
  return data
}

// otk-users.ts's POST /user/:id/add-role — $addToSet, so re-adding an
// already-present role is a no-op rather than a duplicate.
export async function addOtkRole(
  userId: string,
  role: Role
): Promise<OtkUser> {
  const { data } = await apiClient.post<OtkUser>(
    `/otk/users/${userId}/add-role`,
    role
  )
  return data
}

// otk-users.ts's POST /user/:id/remove-role — $pull by exact role match, so
// the request body must equal the stored role verbatim.
export async function removeOtkRole(
  userId: string,
  role: Role
): Promise<OtkUser> {
  const { data } = await apiClient.post<OtkUser>(
    `/otk/users/${userId}/remove-role`,
    role
  )
  return data
}

// otk-users.ts's POST /user/:id/delete — unsets the user's `subjectId`
// rather than deleting the account document, so the person keeps their
// Better Auth login but loses this subject's roles/access.
export async function deleteOtkUser(userId: string): Promise<OtkUser> {
  const { data } = await apiClient.post<OtkUser>(`/otk/users/${userId}/delete`)
  return data
}
